import axios from "lib/axios";
import { PercentileData, PercentileState } from "../store";
import { PERCENTILES_PATH } from "../constants";

export const fetchPercentiles = async (userId: number, testId: number): Promise<PercentileData> => {
  const response: PercentileState = await axios.get(`${PERCENTILES_PATH}/${userId}?test_id=${testId}`);
  return response.data;

}
